module.exports = __webpack_public_path__ + "static/media/02_Nils_petrol.58a1e6ce.png";